
        var result = require("!!../../../node_modules/css-loader/index.js!./loader.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/fw/loader/loader.component.css
// module id = 2295
// module chunks = 1